import axios from "axios";

const isDebug = process.env.REACT_APP_ENV === "DEBUG";
const isLocal = process.env.REACT_APP_ENV === "LOCAL";

const BASE_API_URL = isLocal
  ? "http://localhost:8080/api/wuxingren/auth"
  : isDebug
  ? "https://dev.fortune.leinotek.com/api/wuxingren/auth/"
  : "https://fortune.leinotek.com/api/wuxingren/auth";

class AuthService {
  //google 送審帳戶帳號刪除
  deleteAccount(userEmail) {
    return axios.post(
      BASE_API_URL + "/delete-account-g",
      { userEmail }, // 把 userEmail 放到 body
      {}
    );
  }
}

export default new AuthService();
